const americanFootballData = [
    //Workspace: American Football Usage Insights
    {
        "category": "app",
        "type": 'internal',
        "name": "American Football Usage Insights",
        "keyUsers": "R&D, Business Development",
        "access": "Limited",
        "keyUseCases": "<ul><li>Insights into the usage of the American football product</li></ul>",
        "dataSummary": "<ul><li>History: All available american football data</li><li>Updates Daily: Automatic</li></ul>",
        "reports": [
            {
                reportId: '8daddd21-98d5-4255-ba15-167f02dc3785',
                applicationId: 'a74fbb5e-6564-47e5-8d51-5ed56a38fe8e',
                name: "American Football Usage Insights",
                visible: false
            }
        ]
    }
]


// ****************** UPDATE ALL THE OBJECTS WITH APP URL AND SPORT ****************** //
function createUrlFromName(name) {
    let url = name.toLowerCase();
    url = url.replace(/[^\w\s-]/g, '-');
    url = url.replace(/[\s-]+/g, '-');
    return url;
}

function updateAppIds(objects) {
    objects.forEach(obj => {
        const urlFromName = createUrlFromName(obj.name);
        const sport = 'americanFootball';
        obj.appId = urlFromName;
        obj.sport = sport;
        obj.reports = obj.reports.map(item => ({...item, appId: urlFromName, sport: sport}));
    });
}

updateAppIds(americanFootballData);
export {americanFootballData};